import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { BlogPostItem, PostTag } from 'client/bundles/types';
import Breadcrumbs from 'client/components/breadcrumbs';
import Date from 'client/components/date';
import Link from 'client/components/link';
import TextNoData from 'client/components/text-no-data';
import YablogsPost from 'client/components/yablogs-post';
import LangContext from 'client/utils/lang-context';

import 'client/components/text-blog/index.css';
import 'client/components/text/index.css';
import './index.css';

const b = cn('blog-post');
const bPageTitle = cn('page-title');

interface Props {
    post: BlogPostItem;
}

export default class BlogPostPage extends Component<Props> {
    static contextType = LangContext;

    renderTag = (tag: PostTag) => {
        return (
            <li className={b('tag')} key={tag.displayName}>
                <Link href={tag.url} text={tag.displayName} color="blue" />
            </li>
        );
    }

    render() {
        const { post } = this.props;
        const { dictionary } = this.context;

        return (
            <article className={b()}>
                {/* TODO: IR-618 */}
                <Breadcrumbs link="/blog" text={dictionary.blog} />

                {
                    post.markup ?
                        <>
                            <h1 className={bPageTitle()}>{post.title}</h1>

                            <Date dateStart={post.date} />

                            <div className={b('text', ['text', 'text-blog'])}>
                                <YablogsPost rawHtml={post.markup} />
                            </div>

                            {
                                post.tags.length > 0 &&
                                    <ul className={b('tags-list')}>
                                        {post.tags.map(this.renderTag)}
                                    </ul>
                            }
                        </> :
                        <TextNoData />
                }
            </article>
        );
    }
}
